var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { defaultSocketOptions, } from './framework/CommandSocket';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class I3TouchXOne {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        this.isMacAddressSpecified = false;
        this.modelNumber = '-NLaeW7DjRpc09dWO4Py';
        this.remoteControlCodes = {
            directionEnter: 0x2b,
            directionDown: 0x2f,
            directionLeft: 0x2c,
            directionRight: 0x2d,
            directionUp: 0x2e,
            exit: 0x1d,
            home: 0x1c,
        };
        // Video input source queries return a different value from the 'set' codes. Translate between
        // the returned value and the codes used to set the value.
        this.videoInputMaps = {
            '-NLaeW7DjRpc09dWO4Py': {
                // I3Touch X-One
                0x00: { name: 'usb-c front', setValue: 0x54 },
                0x01: { name: 'usb-c rear', setValue: 0x55 },
                0x17: { name: 'ops pc', setValue: 0x38 },
                0x1e: { name: 'hdmi 2', setValue: 0x53 },
                0x1f: { name: 'hdmi 1', setValue: 0x52 },
                0x20: { name: 'displayPort', setValue: 0x56 },
                0x30: { name: 'android', setValue: 0x1c },
            },
            '-NPP3sSWhSGTS5yu89oL': {
                // Newline NT/NT+
                0x16: { name: 'ops pc', setValue: 0x38 },
                0x17: { name: 'hdmi 4', setValue: 0x55 },
                0x18: { name: 'hdmi 3', setValue: 0x54 },
                0x1e: { name: 'hdmi 2', setValue: 0x53 },
                0x1f: { name: 'hdmi 1', setValue: 0x52 },
            },
            '-NmGtbdWriaFoqkhuyaM': {
                // Note: The documentation shows code 0x53 for HDMI 1 and 0x52 for HDMI2, but based on
                // issues with the documentation for the X-One, I think the documentation is wrong.
                0x00: { name: 'usb-c front', setValue: 0x54 },
                0x01: { name: 'usb-c rear', setValue: 0x55 },
                0x17: { name: 'ops pc', setValue: 0x38 },
                0x1e: { name: 'hdmi 2', setValue: 0x53 },
                0x1f: { name: 'hdmi 1', setValue: 0x52 },
                0x20: { name: 'displayPort', setValue: 0x56 },
                0x30: { name: 'android', setValue: 0x1c },
            },
            '-ORBo4vL4Na35PlIerRC': {
                // Newline Q Pro
                0x20: { name: 'dp', setValue: 0x56 },
                0x00: { name: 'vga/usb-c front', setValue: 0x54 },
                0x01: { name: 'usb-c rear', setValue: 0x55 },
                0x17: { name: 'pc', setValue: 0x38 },
                0x1e: { name: 'hdmi 3', setValue: 0x53 },
                0x1f: { name: 'hdmi 2', setValue: 0x52 },
                0x19: { name: 'hdmi 1', setValue: 0x0a },
            },
        };
        this.videoInputMap = this.videoInputMaps['-NLaeW7DjRpc09dWO4Py'];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayFreeze = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.displayFreeze.value;
            }),
            set: (freeze, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x0b, freeze ? 0x00 : 0x01]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x0b([\s\S])\x01\xcf/, tags);
                return match[1].charCodeAt(0) === 0;
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                return this.modelNumber === '-NmGtbdWriaFoqkhuyaM';
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.mediaOperation = {
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (this.remoteControlCodes.hasOwnProperty(value.operation) &&
                    this.remoteControlCodes[value.operation] !== undefined) {
                    yield this.socket.send(this.makeCommand([0x01, (_a = this.remoteControlCodes[value.operation]) !== null && _a !== void 0 ? _a : 0x1d]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x01([\s\S])\x01\xcf/, tags);
                }
                else {
                    this.log.error(`unhandled media operation: ${value.operation}`);
                }
                return value;
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                return this.modelNumber !== '-NPP3sSWhSGTS5yu89oL';
            }),
            powerOffRestrictions: ['set'],
        };
        this.mediaOperations = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _b, _c;
                const mediaOperationCaps = {};
                const mediaOperations = [
                    'directionUpDownLeftRight',
                    'directionEnter',
                    'exit',
                    'home',
                ];
                for (const input of Object.values((_c = (_b = this.config) === null || _b === void 0 ? void 0 : _b.videoInputs) !== null && _c !== void 0 ? _c : {})) {
                    if (input.code === '\u001C') {
                        // Show navigation commands only on Android input.
                        mediaOperationCaps[input.code] = [...mediaOperations];
                    }
                }
                return mediaOperationCaps;
            }),
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                return this.modelNumber !== '-NPP3sSWhSGTS5yu89oL';
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, 0x37]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x01\x37([\s\S])\xcf/, tags);
                return match[1].charCodeAt(0) === 1; // 0 = power off, 1 = power on
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                // Clear any pending busy timeouts that would set busy back to false. The power set
                // methods will set busy to true and manage the transition back to false.
                this.busyTimeout.clear();
                if (this.isMacAddressSpecified) {
                    if (this.socket.options.allowNoConnection) {
                        return this.setPowerWakeOnLanNetwork(power, tags);
                    }
                    else {
                        return this.setPowerWakeOnLanSerial(power, tags);
                    }
                }
                return this.setPowerSimple(power, tags);
            }),
            powerOffRestrictions: (config) => {
                return config.macAddress === undefined ? [] : ['get'];
            },
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _d;
                const match = yield this.socket.send(this.makeCommand([0x01, 0x50]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x01\x50([\s\S])\xcf/, tags);
                const getSourceCode = match[1].charCodeAt(0);
                const result = (_d = this.videoInputMap[getSourceCode]) === null || _d === void 0 ? void 0 : _d.setValue;
                if (result === undefined) {
                    this.log.warning(`video input code not defined.`);
                    return this.state.videoInput.value;
                }
                return String.fromCharCode(result);
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, code.charCodeAt(0)]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x01([\s\S]{2})\xcf/, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return String.fromCharCode(match[1].charCodeAt(0));
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x01, 0x33]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x01\x33([\s\S])\xcf/, tags);
                return match[1].charCodeAt(0);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x05, volume]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x05([\s\S])\x01\xcf/, tags);
                return match[1].charCodeAt(0);
            }),
            range: { max: 100, min: 0, round: 1 },
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 3000, onePerInterval: true, controls: ['power', 'videoInput'] },
            {
                intervalMs: 5000,
                pollWhenDisconnected: true,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (!this.state.power.value &&
                        this.socket.options.allowNoConnection &&
                        this.socket.getState() !== 'connected') {
                        if (!this.framework.isReconnecting)
                            yield this.framework.reconnect();
                    }
                }),
            },
        ];
        if (this.socket.options.allowNoConnection) {
            // If the display is powered off externally (e.g., IR remote or third party controller),
            // then we will lose the socket connection. If this happens, we update the power state
            // to false.
            this.socket.onConnectionLost(() => {
                this.state.power.update(false, true);
            });
        }
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.config = config;
            this.modelNumber = (_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : '-NLaeW7DjRpc09dWO4Py';
            this.videoInputMap =
                (_b = this.videoInputMaps[this.modelNumber]) !== null && _b !== void 0 ? _b : this.videoInputMaps['-NLaeW7DjRpc09dWO4Py'];
            this.isMacAddressSpecified = config.macAddress !== undefined;
            if (this.isMacAddressSpecified && config.port === undefined) {
                this.log.error(`mac address configured for wake on lan, but no port specified`);
            }
            if (config.macAddress !== undefined) {
                // The mac address is specified, so we can't query the power if the device is powered
                // off. The power is initialized to false, but we need to query it if we can when we
                // first connect.
                if (this.socket.port !== 6688 || this.socket.state === 'connected') {
                    this.state.power.update(yield this.power.get(['power.get']));
                }
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socket.state === 'connected') {
                const result = yield CommandSocketInitializer.initialize(this.socket, [
                    {
                        errorCode: 'verifyFailed',
                        send: `\x7f\x08\x99\xa2\xb3\xc4\x02\xff\x01\x37\xcf`,
                        next: /\x7f[\s\S]\x99\xa2\xb3\xc4\x02\xff\x01\x37[\s\S]\xcf/,
                    },
                ], credentials);
                return result;
            }
            else if (this.socket.options.allowNoConnection) {
                return 'connected';
            }
            return 'connectFailed';
        });
    }
    // other class methods
    makeCommand(data) {
        const command = [
            0x7f,
            6 + data.length,
            0x99,
            0xa2,
            0xb3,
            0xc4,
            0x02,
            0xff,
            ...data,
            0xcf,
        ];
        return AsciiText.decode(command);
    }
    setPowerSimple(power, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.state.busy.update(true);
            this.state.power.update(power);
            try {
                // Sometimes the display responds with UNSELECTED to a power set command. If this
                // happens, we should just resend the power set command. We try several times before
                // giving up.
                //
                // Also, since we may be sending multiple commands, we suspend polling so no polls
                // happen between the power set commands which could cause the power state to appear to
                // bounce.
                this.framework.suspendPolling(30000);
                const match = yield this.socket.send(this.makeCommand([0x01, power ? 0x00 : 0x01]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x01([\s\S])\x01\xcf/, tags);
                power = match[1].charCodeAt(0) === 0;
                // The display will stop responding to commands for about 30 seconds once it is powered
                // on or off.
                this.busyTimeout.set(() => this.state.busy.update(false), 30000);
                this.framework.suspend(30000);
                this.state.power.update(power);
            }
            catch (_a) { }
            return this.state.power.value;
        });
    }
    setPowerWakeOnLanNetwork(power, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.framework.suspendPolling(15000);
            this.socket.removeCommands('poll');
            if (power) {
                // Send a power on command in case wake on lan is not actually required.
                if (this.socket.state === 'connected') {
                    yield this.socket.sendAsync(this.makeCommand([0x01, 0x00]), tags);
                }
                // For direct Ethernet connections where the socket connection is lost when the display
                // is powered off, we first uppdate the power state so the UI will reflect that the
                // power is on, then we block while sending a wake on lan request and attempting to
                // reconnect to the display.
                this.state.busy.update(true);
                // Update power with a short delay so that framework.reconnect gets called first. This
                // tells StateBridge we are disconnected so it doesn't change phase back to configuring
                // to query the controls with power off restrictions when it sees that the power is
                // back on.
                this.timeouts.set(() => this.state.power.update(power), 100);
                yield this.framework.reconnect({
                    attemptDelayMs: 1000,
                    initialDelayMs: 0,
                    numAttempts: 8,
                    onBeforeReconnect: () => __awaiter(this, void 0, void 0, function* () {
                        return this.framework.sendWakeOnLan();
                    }),
                });
                // When updating the busy state, we must use notifyIfUnchanged = true. This/ is because
                // the driver reconnects as part of powering on, and reconnecting resets all the states.
                // Without notifyIfUnchanged = true, the busy = false notification won't get sent.
                this.state.busy.update(false, true);
                return this.socket.state === 'connected';
            }
            else {
                return this.setPowerSimple(power, tags);
            }
        });
    }
    setPowerWakeOnLanSerial(power, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.framework.suspendPolling(6000);
            this.socket.removeCommands('poll');
            if (power) {
                // Send a power on command in case wake on lan is not actually required.
                yield this.socket.sendAsync(this.makeCommand([0x01, 0x00]), tags);
                // For serial connections where the display is unresponsive when powered off, first we
                // update the power state so the UI will reflect that the power is on, then we block
                // while sending a wake on lan request, then we continue blocking while sending some
                // power requests to confirm that the power is on, finally we return the new power
                // state.
                this.state.busy.update(true);
                this.state.power.update(true);
                let newPower = false;
                for (let i = 0; i < 4; i++) {
                    this.framework.suspendPolling(6000);
                    yield this.framework.sendWakeOnLan();
                    try {
                        const match = yield this.socket.send(this.makeCommand([0x01, 0x37]), /\x7F\x09\x99\xA2\xB3\xC4\x02\xFF\x01\x37([\s\S])\xcf/, ['power.get']);
                        newPower = match[1].charCodeAt(0) === 1;
                        break;
                    }
                    catch (_a) { }
                }
                this.state.busy.update(false);
                return newPower;
            }
            else {
                return this.setPowerSimple(power, tags);
            }
        });
    }
}
// static properties
I3TouchXOne.driverType = 'socketDriver';
I3TouchXOne.key = '-NMAojcsneFqYF6MUdAE';
I3TouchXOne.socketOptions = (config) => {
    const baseSocketOptions = {
        commandExtractor: (buffer) => {
            // Command Format:
            //   0x7F [length] 0x99 0xA2 0xB3 0xC4 0x02 0xFF 0x01 [data] 0xCF
            //
            // Try each byte as a starting position in case we receive any corrupted data.
            for (let i = 0; i < buffer.length - 1; i++) {
                // Commands start with 0x7f and end with 0xcf.
                if (buffer.charCodeAt(i) !== 0x7f)
                    continue;
                const cmdLength = buffer.charCodeAt(i + 1);
                if (i + cmdLength + 3 <= buffer.length &&
                    buffer.charCodeAt(cmdLength + 2) === 0xcf) {
                    const command = buffer.slice(i, i + cmdLength + 3);
                    buffer = buffer.slice(i + cmdLength + 3);
                    return { command, buffer };
                }
            }
            return undefined;
        },
        sendTerminator: '',
        isBinary: true,
    };
    const hasMacAddress = config.macAddress !== undefined;
    if (config.port === undefined) {
        return [
            Object.assign(Object.assign({}, baseSocketOptions), { port: 6688, allowNoConnection: hasMacAddress }),
            Object.assign(Object.assign({}, baseSocketOptions), { port: 4999, idleTimeoutMs: hasMacAddress ? 0 : defaultSocketOptions.idleTimeoutMs, allowNoConnection: false }),
        ];
    }
    // Assume port 6688 is direct Ethernet to the device and anything else is via an Ethernet
    // to serial converter.
    return [
        Object.assign(Object.assign({}, baseSocketOptions), { port: config.port, idleTimeoutMs: hasMacAddress && config.port !== 6688 ? 0 : defaultSocketOptions.idleTimeoutMs, allowNoConnection: hasMacAddress && config.port === 6688 }),
    ];
};
